// extracted by mini-css-extract-plugin
export default {"lockIcon":"UncategorisedDropDown_lockIcon__wNpXE","buttonStyle":"UncategorisedDropDown_buttonStyle__qK+Ma","uncategorisedText":"UncategorisedDropDown_uncategorisedText__6wYVU"};